<div class="client-history-container">

  <!-- ═══════════════ Breadcrumb ═══════════════ -->
  <nav class="crumb-bar">
    <a class="crumb-link" href="javascript:void(0)" (click)="backToLawyers()">
      LexiZ Lawyers
    </a>
    <i class="bi bi-chevron-right crumb-sep"></i>
    <span class="crumb-current">{{ lawyer?.name || 'Lawyer' }}</span>
  </nav>

  <div class="history-layout" [class.detail-open]="detailKind">

    <!-- ═══════════════════════════════════════════════════════
                          MAIN COLUMN
    ═══════════════════════════════════════════════════════ -->
    <div class="history-main">

      <!-- ── Lawyer card ── -->
      <div class="client-card">

        <div class="client-identity">

          <div class="client-avatar">{{ initials(lawyer?.name) }}</div>

          <div class="client-identity-text">

            <div class="client-name-row">
              <h5 class="client-name">{{ lawyer?.name || '-' }}</h5>
              <span class="type-badge">Lawyer</span>
            </div>

            <div class="client-contact">
              <span class="contact-item" *ngIf="lawyer?.email">
                <i class="bi bi-envelope"></i>
                <a [href]="'mailto:' + lawyer?.email">{{ lawyer?.email }}</a>
              </span>

              <span class="contact-item" *ngIf="lawyer?.mobile">
                <i class="bi bi-telephone"></i>
                <a [href]="'tel:' + lawyer?.mobile">{{ lawyer?.mobile }}</a>
              </span>
            </div>

          </div>

        </div>

        <div class="client-meta">

          <div class="meta-item">
            <span class="meta-label">Lawyer ID</span>
            <span class="meta-value mono" [title]="lawyer?.id || ''">
              {{ shortId(lawyer?.id) }}
            </span>
          </div>

          <div class="meta-item">
            <span class="meta-label">Registered On</span>
            <span class="meta-value">{{ formatDate(lawyer?.registered_on) }}</span>
          </div>

          <div class="meta-item">
            <span class="meta-label">Last Login</span>
            <span class="meta-value">{{ formatDateTime(lawyer?.last_login) }}</span>
          </div>

          <div class="meta-item">
            <span class="meta-label">Plan</span>
            <span class="meta-value">{{ (lawyer?.plan | titlecase) || '-' }}</span>
          </div>

        </div>

      </div>

      <!-- ── Summary cards ── -->
      <div class="summary-grid summary-grid-5">

        <!-- Total Appointments -->
        <div class="summary-card">
          <div class="summary-top">
            <div class="summary-icon icon-blue">
              <i class="bi bi-calendar2-week"></i>
            </div>
            <div class="summary-text">
              <div class="summary-label">Total Appointments</div>
              <div class="summary-value">{{ summary?.appointments?.total || 0 }}</div>
            </div>
          </div>

          <div class="summary-foot">
            <span class="foot-item">
              Completed <strong>{{ summary?.appointments?.completed || 0 }}</strong>
            </span>
            <span class="foot-divider"></span>
            <span class="foot-item">
              Cancelled <strong>{{ summary?.appointments?.cancelled || 0 }}</strong>
            </span>
            <span class="foot-divider"></span>
            <span class="foot-item">
              Upcoming <strong>{{ summary?.appointments?.upcoming || 0 }}</strong>
            </span>
            <span class="foot-divider"></span>
            <span class="foot-item">
              Ongoing <strong>{{ summary?.appointments?.ongoing || 0 }}</strong>
            </span>
          </div>
        </div>

        <!-- Total Settlement Amount -->
        <div class="summary-card">
          <div class="summary-top">
            <div class="summary-icon icon-green">
              <i class="bi bi-currency-rupee"></i>
            </div>
            <div class="summary-text">
              <div class="summary-label">Total Settlement Amount</div>
              <div class="summary-value">
                {{ money(summary?.consultation_value?.amount, summary?.currency) }}
              </div>
            </div>
          </div>

          <div class="summary-foot">
            <span class="foot-item">
              Across
              <strong>{{ summary?.consultation_value?.appointments || 0 }}</strong>
              <span class="foot-muted"> appointments</span>
            </span>
            <span class="foot-divider"></span>
            <!-- <span class="foot-item foot-muted">
              Completed, upcoming &amp; ongoing
            </span> -->
          </div>
        </div>

        <!-- Total Settled -->
        <div class="summary-card">
          <div class="summary-top">
            <div class="summary-icon icon-purple">
              <i class="bi bi-wallet2"></i>
            </div>
            <div class="summary-text">
              <div class="summary-label">Total Settled</div>
              <div class="summary-value">
                {{ money(summary?.settled?.amount, summary?.currency) }}
              </div>
            </div>
          </div>

          <div class="summary-foot">
            <span class="foot-item">
              Across <strong>{{ summary?.settled?.payouts || 0 }}</strong> payouts
            </span>
            <span class="foot-divider"></span>
            <span class="foot-item foot-muted">
              {{ summary?.settled?.appointments || 0 }}
              of {{ summary?.settled?.total_appointments || 0 }} appointments
            </span>
          </div>
        </div>

        <!-- Net Settled -->
        <div class="summary-card">
          <div class="summary-top">
            <div class="summary-icon icon-amber">
              <i class="bi bi-hourglass-split"></i>
            </div>
            <div class="summary-text">
              <div class="summary-label">Net Settled</div>
              <div class="summary-value">
                {{ money(summary?.pending_settlement?.remaining_amount,
                         summary?.currency) }}
              </div>
            </div>
          </div>

          <div class="summary-foot">
            <span class="foot-item foot-muted">Still to settle</span>
            <!-- <span class="foot-divider"></span>
            <span class="foot-item">
              <strong>{{ summary?.pending_settlement?.payouts || 0 }}</strong>
              payouts pending
            </span> -->
            <span class="foot-divider"></span>
            <span class="foot-item foot-muted">
              {{ summary?.pending_settlement?.remaining_appointments || 0 }}
              of {{ summary?.pending_settlement?.total_appointments || 0 }} appointments
            </span>
          </div>
        </div>

        <!-- Taxes & Platform Fee -->
        <div class="summary-card">
          <div class="summary-top">
            <div class="summary-icon icon-slate">
              <i class="bi bi-receipt-cutoff"></i>
            </div>
            <div class="summary-text">
              <div class="summary-label">Taxes &amp; Platform Fee</div>
              <div class="summary-value">
                {{ money(summary?.taxes?.amount, summary?.currency) }}
              </div>
            </div>
          </div>

          <div class="summary-foot">
            <span class="foot-item">
              Fee <strong>{{ money(summary?.taxes?.platform_fee, summary?.currency) }}</strong>
            </span>
            <span class="foot-divider"></span>
            <span class="foot-item">
              GST <strong>{{ money(summary?.taxes?.gst, summary?.currency) }}</strong>
            </span>
            <span class="foot-divider"></span>
            <span class="foot-item foot-muted">
              across all {{ summary?.taxes?.appointments || 0 }} appointments
            </span>
          </div>
        </div>

      </div>

      <!-- ── Tabs + tab body ── -->
      <div class="tab-card">

        <div class="tab-bar">
          <button class="tab-btn"
                  [class.active]="activeTab === 'appointments'"
                  (click)="selectTab('appointments')">
            Appointments
          </button>

          <button class="tab-btn"
                  [class.active]="activeTab === 'settlements'"
                  (click)="selectTab('settlements')">
            Settlements
          </button>

          <!-- <button class="tab-btn"
                  [class.active]="activeTab === 'earnings'"
                  (click)="selectTab('earnings')">
            Earnings Summary
          </button> -->

          <button class="tab-btn"
                  [class.active]="activeTab === 'activity'"
                  (click)="selectTab('activity')">
            Activity
          </button>
        </div>

        <div class="tab-body">

          <!-- Toolbar (shared; the active tab supplies its own state) -->
          <div class="tab-header">

            <h6 class="tab-title">
              {{ tabTitle }}
              <span class="count-badge" *ngIf="activeTab !== 'earnings'">
                {{ state.pagination?.total || 0 }}
              </span>
            </h6>

            <div class="tab-tools">

              <!-- Date range -->
              <div class="tool-wrap" (click)="$event.stopPropagation()">
                <button class="tool-btn" (click)="toggleDateMenu($event)">
                  <i class="bi bi-calendar3"></i>
                  <span class="tool-text">{{ dateRangeLabel }}</span>
                  <i class="bi bi-chevron-down tool-caret"></i>
                </button>

                <div class="tool-menu" *ngIf="showDateMenu">
                  <div class="menu-title">Date range</div>

                  <label class="menu-label">From</label>
                  <input type="date" class="form-control" [(ngModel)]="state.draftStart">

                  <label class="menu-label">To</label>
                  <input type="date" class="form-control" [(ngModel)]="state.draftEnd">

                  <div class="menu-actions">
                    <button class="btn btn-link btn-clear" (click)="clearDateRange()">
                      Clear
                    </button>
                    <button class="btn btn-apply" (click)="applyDateRange()">
                      Apply
                    </button>
                  </div>
                </div>
              </div>

              <!-- Status / event type -->
              <div class="tool-wrap" *ngIf="hasStatusFilter">
                <select class="tool-select"
                        [(ngModel)]="state.status"
                        (change)="onFilterChange()">
                  <option *ngFor="let option of statusOptionsForTab"
                          [value]="option.value">
                    {{ option.value ? option.label : statusPlaceholder }}
                  </option>
                </select>
              </div>

              <!-- Extra filters -->
              <div class="tool-wrap"
                   *ngIf="hasFilterMenu"
                   (click)="$event.stopPropagation()">
                <button class="tool-btn" (click)="toggleFilterMenu($event)">
                  <i class="bi bi-funnel"></i>
                  <span class="tool-text">Filter</span>
                  <span class="filter-count" *ngIf="activeFilterCount">
                    {{ activeFilterCount }}
                  </span>
                </button>

                <div class="tool-menu" *ngIf="showFilterMenu">

                  <ng-container *ngIf="activeTab === 'appointments'">
                    <div class="menu-title">Filter appointments</div>

                    <label class="menu-label">Consultation mode</label>
                    <select class="form-select" [(ngModel)]="appt.draftMode">
                      <option *ngFor="let option of consultationModeOptions"
                              [value]="option.value">
                        {{ option.label }}
                      </option>
                    </select>

                    <label class="menu-label">Client or appointment id</label>
                    <input type="text"
                           class="form-control"
                           placeholder="Search"
                           [(ngModel)]="appt.draftSearch"
                           (keyup.enter)="applyFilters()">
                  </ng-container>

                  <ng-container *ngIf="activeTab === 'settlements'">
                    <div class="menu-title">Filter settlements</div>

                    <label class="menu-label">UTR or payout reference</label>
                    <input type="text"
                           class="form-control"
                           placeholder="Search"
                           [(ngModel)]="settle.draftSearch"
                           (keyup.enter)="applyFilters()">
                  </ng-container>

                  <div class="menu-actions">
                    <button class="btn btn-link btn-clear" (click)="resetFilters()">
                      Reset
                    </button>
                    <button class="btn btn-apply" (click)="applyFilters()">
                      Apply
                    </button>
                  </div>
                </div>
              </div>

              <!-- Export (settlements) -->
              <button class="btn-export"
                      *ngIf="canExport"
                      [disabled]="exporting || !state.rows.length"
                      (click)="exportRows()">
                <i class="bi" [ngClass]="exporting
                                          ? 'bi-arrow-repeat spin'
                                          : 'bi-download'"></i>
                {{ exporting ? 'Exporting…' : 'Export' }}
              </button>

            </div>

          </div>

          <!-- ── Appointments table ── -->
          <div class="history-table"
               *ngIf="activeTab === 'appointments' && !appt.loading && appt.rows.length > 0">

            <table class="table">

              <thead>
                <tr>
                  <th class="thdata">Date &amp; Time</th>
                  <th class="thdata">Appointment ID</th>
                  <th class="thdata">Client</th>
                  <th class="thdata hide-md">Consultation</th>
                  <th class="thdata">Gross Amount</th>
                  <th class="thdata">Net Payable</th>
                  <th class="thdata">Status</th>
                </tr>
              </thead>

              <tbody>
                <tr class="row-link"
                    *ngFor="let row of appt.rows; trackBy: trackByAppointment"
                    [class.row-selected]="isSelected('appointment', row.appointment_id)"
                    (click)="openAppointment(row)"
                    tabindex="0"
                    (keyup.enter)="openAppointment(row)">

                  <td>
                    <div class="cell-strong">{{ formatDate(row.appointment_from) }}</div>
                    <div class="cell-sub">{{ formatTime(row.appointment_from) }}</div>
                  </td>

                  <td>
                    <span class="mono" [title]="row.appointment_id">
                      {{ shortId(row.appointment_id) }}
                    </span>
                  </td>

                  <td>{{ row.client?.name || '-' }}</td>

                  <td class="hide-md">
                    <div class="cell-strong">{{ row.consultation_type || '-' }}</div>
                    <div class="cell-sub">{{ modeLabel(row.consultation_mode) }}</div>
                  </td>

                  <td>{{ money(row.gross_amount, row.currency) }}</td>

                  <td class="cell-strong">{{ money(row.net_payable, row.currency) }}</td>

                  <td>
                    <span class="status-badge" [ngClass]="statusClass(row.status)">
                      {{ statusLabel(row.status) }}
                    </span>
                  </td>

                </tr>
              </tbody>

            </table>

          </div>

          <!-- ── Settlements table ── -->
          <div class="history-table"
               *ngIf="activeTab === 'settlements' && !settle.loading && settle.rows.length > 0">

            <table class="table">

              <thead>
                <tr>
                  <th class="thdata">Payout Date</th>
                  <th class="thdata">Payout ID</th>
                  <th class="thdata">Appointments</th>
                  <th class="thdata">Gross Amount</th>
                  <th class="thdata">Lawyer Payable (Net)</th>
                  <th class="thdata hide-lg">UTR / Reference</th>
                  <th class="thdata">Status</th>
                </tr>
              </thead>

              <tbody>
                <tr class="row-link"
                    *ngFor="let row of settle.rows; trackBy: trackByPayout"
                    [class.row-selected]="isSelected('payout', row.payout_id)"
                    (click)="openPayout(row)"
                    tabindex="0"
                    (keyup.enter)="openPayout(row)">

                  <td>
                    <div class="cell-strong">{{ formatDate(row.payout_date) }}</div>
                    <div class="cell-sub">{{ formatTime(row.payout_date) }}</div>
                  </td>

                  <td>
                    <span class="mono link-text"
                          [title]="row.razorpay_payout_id || row.payout_id">
                      {{ row.razorpay_payout_id || shortId(row.payout_id) }}
                    </span>
                  </td>

                  <td>{{ row.appointments || 0 }}</td>

                  <td>{{ money(row.gross_amount, row.currency) }}</td>

                  <td class="cell-strong">{{ money(row.net_payable, row.currency) }}</td>

                  <td class="hide-lg">
                    <span class="mono">{{ row.utr || '-' }}</span>
                  </td>

                  <td>
                    <span class="status-badge" [ngClass]="paymentStatusClass(row.status)">
                      {{ statusLabel(row.status) }}
                    </span>
                  </td>

                </tr>
              </tbody>

            </table>

          </div>

          <!-- ── Earnings summary ── -->
          <div class="earnings-wrap"
               *ngIf="activeTab === 'earnings' && !earn.loading && earn.data">

            <p class="tab-subtitle">
              Everything this lawyer has earned in the selected period.
            </p>

            <div class="earnings-grid">

              <div class="earnings-card">
                <span class="earnings-label">Gross Amount</span>
                <span class="earnings-value">
                  {{ money(earn.data?.gross_amount, earn.data?.currency) }}
                </span>
                <span class="earnings-note">
                  Across {{ earn.data?.order_count || 0 }} paid consultations
                </span>
              </div>

              <div class="earnings-card">
                <span class="earnings-label">Platform Commission</span>
                <span class="earnings-value">
                  {{ money(earn.data?.commission_amount, earn.data?.currency) }}
                </span>
                <span class="earnings-note">Kept by the platform</span>
              </div>

              <div class="earnings-card highlight">
                <span class="earnings-label">Net Earnings</span>
                <span class="earnings-value">
                  {{ money(earn.data?.net_earnings, earn.data?.currency) }}
                </span>
                <span class="earnings-note">Gross - commission</span>
              </div>

              <div class="earnings-card">
                <span class="earnings-label">Settled</span>
                <span class="earnings-value">
                  {{ money(earn.data?.settled_amount, earn.data?.currency) }}
                </span>
                <span class="earnings-note">Paid out</span>
              </div>

              <div class="earnings-card">
                <span class="earnings-label">Pending</span>
                <span class="earnings-value">
                  {{ money(earn.data?.pending_amount, earn.data?.currency) }}
                </span>
                <span class="earnings-note">In flight or queued</span>
              </div>

              <div class="earnings-card">
                <span class="earnings-label">Reversed</span>
                <span class="earnings-value">
                  {{ money(earn.data?.reversed_amount, earn.data?.currency) }}
                </span>
                <span class="earnings-note">Returned to the platform</span>
              </div>

            </div>

          </div>

          <!-- ── Activity timeline ── -->
          <ng-container
            *ngIf="activeTab === 'activity' && !act.loading && act.rows.length > 0">

            <p class="tab-subtitle">
              Complete timeline of all activities related to this lawyer.
            </p>

            <div class="activity-list">

              <div class="activity-row"
                   *ngFor="let row of act.rows; trackBy: trackByActivity"
                   [class.row-selected]="isSelected('activity', row.event_id)"
                   (click)="openActivity(row)"
                   tabindex="0"
                   (keyup.enter)="openActivity(row)">

                <span class="activity-icon" [ngClass]="activityTone(row.type)">
                  <i class="bi" [ngClass]="activityIcon(row.type)"></i>
                </span>

                <div class="activity-text">
                  <div class="activity-title">
                    {{ row.title }}
                    <span class="ref-chip" *ngIf="row.reference"
                          [title]="row.reference">
                      {{ shortId(row.reference) }}
                    </span>
                  </div>
                  <div class="activity-desc">{{ row.description || '-' }}</div>
                </div>

                <div class="activity-when">
                  <div class="activity-time">{{ formatDateTime(row.timestamp) }}</div>
                  <div class="activity-actor">{{ row.performed_by || 'System' }}</div>
                </div>

              </div>

            </div>

          </ng-container>

          <!-- Skeleton -->
          <div class="skeleton-wrapper" *ngIf="state.loading">
            <div class="skeleton-row" *ngFor="let row of [1,2,3,4,5,6]">
              <div class="skeleton-cell wide"></div>
              <div class="skeleton-cell medium"></div>
              <div class="skeleton-cell medium"></div>
              <div class="skeleton-cell wide hide-md"></div>
              <div class="skeleton-cell small"></div>
              <div class="skeleton-cell medium"></div>
            </div>
          </div>

          <!-- Empty -->
          <div class="empty-state" *ngIf="!state.loading && state.rows.length === 0">
            <i class="bi empty-icon"
               [ngClass]="{
                 'bi-calendar-x': activeTab === 'appointments',
                 'bi-cash-stack': activeTab === 'settlements',
                 'bi-graph-up': activeTab === 'earnings',
                 'bi-clock-history': activeTab === 'activity'
               }"></i>
            <p class="empty-title">
              {{ activeTab === 'earnings'
                  ? 'No earnings in this period'
                  : 'No ' + rowNoun + ' found' }}
            </p>
            <p class="empty-sub">
              Try widening the date range or clearing the filters.
            </p>
          </div>

          <!-- Pagination -->
          <div class="pagination-area"
               *ngIf="activeTab !== 'earnings' && !state.loading && state.rows.length > 0">

            <div class="pagination-info">{{ getPaginationRange() }}</div>

            <div class="pagination-controls">

              <nav>
                <ul class="pagination mb-0">

                  <li class="page-item"
                      [ngClass]="{'disabled': state.pagination.page <= 1}">
                    <a class="page-link" href="javascript:void(0)"
                       (click)="goToPrevPage()">
                      <i class="bi bi-chevron-left"></i>
                    </a>
                  </li>

                  <li class="page-item"
                      *ngFor="let page of getPageNumbers()"
                      [ngClass]="{'active': page === state.pagination.page}">
                    <a class="page-link" href="javascript:void(0)"
                       (click)="goToPage(page)">{{ page }}</a>
                  </li>

                  <li class="page-item"
                      [ngClass]="{'disabled': state.pagination.page >= getTotalPages()}">
                    <a class="page-link" href="javascript:void(0)"
                       (click)="goToNextPage()">
                      <i class="bi bi-chevron-right"></i>
                    </a>
                  </li>

                </ul>
              </nav>

              <select class="page-size"
                      [ngModel]="state.pagination.limit"
                      (ngModelChange)="changePageSize($event)">
                <option *ngFor="let size of pageSizeOptions" [ngValue]="size">
                  {{ size }} / page
                </option>
              </select>

            </div>

          </div>

          <!-- Load more (activity only) -->
          <div class="load-more-area" *ngIf="canLoadMore">
            <button class="btn-load-more"
                    [disabled]="act.loadingMore"
                    (click)="loadActivity(true)">
              {{ act.loadingMore ? 'Loading…' : 'Load More Activities' }}
            </button>
          </div>

        </div>

      </div>

      <!-- ── Recent settlements (appointments tab) ── -->
      <div class="tab-card recent-card"
           *ngIf="activeTab === 'appointments' && recentSettlements.length > 0">

        <div class="tab-body">

          <div class="tab-header">
            <h6 class="tab-title">
              Recent Settlements
              <span class="count-badge">{{ recentTotal }}</span>
            </h6>

            <button class="btn-outline" (click)="selectTab('settlements')">
              View All Settlements
            </button>
          </div>

          <div class="history-table">

            <table class="table">

              <thead>
                <tr>
                  <th class="thdata">Payout ID</th>
                  <th class="thdata">Payout Date</th>
                  <th class="thdata">Appointments</th>
                  <th class="thdata">Gross Amount</th>
                  <th class="thdata">Net Payable</th>
                  <th class="thdata">Status</th>
                  <th class="thdata hide-lg">UTR</th>
                </tr>
              </thead>

              <tbody>
                <tr class="row-link"
                    *ngFor="let row of recentSettlements; trackBy: trackByPayout"
                    [class.row-selected]="isSelected('payout', row.payout_id)"
                    (click)="openPayout(row)"
                    tabindex="0"
                    (keyup.enter)="openPayout(row)">

                  <td>
                    <span class="mono link-text"
                          [title]="row.razorpay_payout_id || row.payout_id">
                      {{ row.razorpay_payout_id || shortId(row.payout_id) }}
                    </span>
                  </td>

                  <td>{{ formatDate(row.payout_date) }}</td>

                  <td>{{ row.appointments || 0 }}</td>

                  <td>{{ money(row.gross_amount, row.currency) }}</td>

                  <td>{{ money(row.net_payable, row.currency) }}</td>

                  <td>
                    <span class="status-badge" [ngClass]="paymentStatusClass(row.status)">
                      {{ statusLabel(row.status) }}
                    </span>
                  </td>

                  <td class="hide-lg">
                    <span class="mono">{{ row.utr || '-' }}</span>
                  </td>

                </tr>
              </tbody>

            </table>

          </div>

        </div>

      </div>

    </div>

    <!-- ═══════════════════════════════════════════════════════
                        DETAIL PANEL
    ═══════════════════════════════════════════════════════ -->
    <div class="detail-backdrop" *ngIf="detailKind" (click)="closeDetail()"></div>

    <aside class="detail-panel" *ngIf="detailKind">

      <div class="detail-header">
        <h6 class="detail-title">
          {{ detailKind === 'payout' ? 'Payout Details'
             : detailKind === 'activity' ? 'Activity Details'
             : 'Appointment Details' }}
        </h6>
        <button class="detail-close" (click)="closeDetail()">
          <i class="bi bi-x-lg"></i>
        </button>
      </div>

      <!-- ── Appointment detail ── -->
      <div class="detail-body"
           *ngIf="!detailLoading && detail && detailKind === 'appointment'">

        <div class="detail-head-row">
          <span class="detail-id" [title]="detail.appointment?.appointment_id">
            {{ shortId(detail.appointment?.appointment_id) }}
          </span>

          <span class="status-badge" [ngClass]="statusClass(detail.appointment?.status)">
            {{ statusLabel(detail.appointment?.status) }}
          </span>
        </div>

        <div class="detail-section">
          <div class="section-title">Client</div>

          <div class="party-row">
            <div class="party-icon"><i class="bi bi-person"></i></div>
            <div class="party-text">
              <div class="cell-strong">{{ detail.client?.name || '-' }}</div>
              <div class="cell-sub">
                <span *ngIf="detail.client?.email">{{ detail.client?.email }}</span>
                <span *ngIf="detail.client?.phone">
                  &nbsp;|&nbsp; {{ detail.client?.phone }}
                </span>
              </div>
            </div>
          </div>
        </div>

        <div class="detail-section">
          <div class="section-title">Consultation</div>

          <div class="detail-rows">

            <div class="row-item">
              <span class="row-label">Type</span>
              <span class="row-value">
                {{ detail.appointment?.consultation_type || '-' }}
              </span>
            </div>

            <div class="row-item">
              <span class="row-label">Mode</span>
              <span class="row-value">
                {{ modeLabel(detail.appointment?.consultation_mode) }}
              </span>
            </div>

            <div class="row-item">
              <span class="row-label">Duration</span>
              <span class="row-value">
                {{ detail.appointment?.duration_minutes
                    ? detail.appointment?.duration_minutes + ' minutes' : '-' }}
              </span>
            </div>

            <div class="row-item">
              <span class="row-label">Scheduled For</span>
              <span class="row-value">
                {{ formatDateTime(detail.appointment?.appointment_from) }}
              </span>
            </div>

            <div class="row-item">
              <span class="row-label">Booking Date</span>
              <span class="row-value">
                {{ formatDateTime(detail.appointment?.booked_at) }}
              </span>
            </div>

          </div>
        </div>

        <div class="detail-section">
          <div class="section-title">Amounts</div>

          <div class="detail-rows">

            <div class="row-item">
              <span class="row-label">Consultation Fee (Gross)</span>
              <span class="row-value">
                {{ money(detail.amounts?.gross_amount, detail.amounts?.currency) }}
              </span>
            </div>

            <div class="row-item">
              <span class="row-label">
                Platform Fee{{ percentOf(detail.amounts?.platform_fee,
                                         detail.amounts?.gross_amount) }}
              </span>
              <span class="row-value negative">
                - {{ money(detail.amounts?.platform_fee, detail.amounts?.currency) }}
              </span>
            </div>

            <div class="row-item">
              <span class="row-label">
                GST{{ percentOf(detail.amounts?.gst, detail.amounts?.platform_fee) }}
              </span>
              <span class="row-value negative">
                - {{ money(detail.amounts?.gst, detail.amounts?.currency) }}
              </span>
            </div>

            <div class="row-item total-row">
              <span class="row-label">Net Payable to Lawyer</span>
              <span class="row-value positive">
                {{ money(detail.amounts?.net_payable, detail.amounts?.currency) }}
              </span>
            </div>

          </div>
        </div>

        <div class="detail-section">
          <div class="section-head">
            <div class="section-title">Payment</div>
            <span class="status-badge"
                  [ngClass]="paymentStatusClass(detail.payment?.status)"
                  *ngIf="detail.payment">
              {{ statusLabel(detail.payment?.status) }}
            </span>
            <span class="status-badge status-default" *ngIf="!detail.payment">
              No Payment
            </span>
          </div>

          <div class="detail-rows" *ngIf="detail.payment">

            <div class="row-item">
              <span class="row-label">Payment ID</span>
              <span class="row-value mono copy-value">
                {{ detail.payment?.payment_id || '-' }}
                <button class="copy-btn"
                        *ngIf="detail.payment?.payment_id"
                        title="Copy payment id"
                        (click)="copy(detail.payment?.payment_id, 'Payment ID')">
                  <i class="bi bi-clipboard"></i>
                </button>
              </span>
            </div>

            <div class="row-item">
              <span class="row-label">Payment Date</span>
              <span class="row-value">{{ formatDateTime(detail.payment?.paid_at) }}</span>
            </div>

            <div class="row-item">
              <span class="row-label">Method</span>
              <span class="row-value">{{ modeLabel(detail.payment?.method) }}</span>
            </div>

            <div class="row-item">
              <span class="row-label">Razorpay Order ID</span>
              <span class="row-value mono copy-value">
                {{ detail.payment?.razorpay_order_id || '-' }}
                <button class="copy-btn"
                        *ngIf="detail.payment?.razorpay_order_id"
                        title="Copy order id"
                        (click)="copy(detail.payment?.razorpay_order_id, 'Order ID')">
                  <i class="bi bi-clipboard"></i>
                </button>
              </span>
            </div>

            <div class="row-item">
              <span class="row-label">Razorpay Payment ID</span>
              <span class="row-value mono copy-value">
                {{ detail.payment?.razorpay_payment_id || '-' }}
                <button class="copy-btn"
                        *ngIf="detail.payment?.razorpay_payment_id"
                        title="Copy payment id"
                        (click)="copy(detail.payment?.razorpay_payment_id, 'Payment ID')">
                  <i class="bi bi-clipboard"></i>
                </button>
              </span>
            </div>

          </div>

          <p class="section-empty" *ngIf="!detail.payment">
            No payment recorded for this appointment.
          </p>
        </div>

        <div class="detail-section">
          <div class="section-head">
            <div class="section-title">Settlement</div>
            <span class="status-badge"
                  [ngClass]="paymentStatusClass(detail.settlement?.payout_status
                                                || detail.settlement?.status)">
              {{ statusLabel(detail.settlement?.payout_status
                             || detail.settlement?.status) }}
            </span>
          </div>

          <div class="detail-rows">

            <div class="row-item">
              <span class="row-label">Settlement Invoice</span>
              <span class="row-value mono">
                {{ detail.settlement?.invoice_code || '-' }}
              </span>
            </div>

            <div class="row-item">
              <span class="row-label">Net Payable</span>
              <span class="row-value">
                {{ money(detail.settlement?.net_payable, detail.settlement?.currency) }}
              </span>
            </div>

            <div class="row-item">
              <span class="row-label">Payout</span>
              <span class="row-value mono"
                    [title]="detail.settlement?.payout_id || ''">
                {{ detail.settlement?.razorpay_payout_id
                   || shortId(detail.settlement?.payout_id) }}
              </span>
            </div>

            <div class="row-item">
              <span class="row-label">Payout Status</span>
              <span class="row-value">
                {{ statusLabel(detail.settlement?.payout_status) }}
              </span>
            </div>

            <div class="row-item" *ngIf="detail.settlement?.utr">
              <span class="row-label">UTR</span>
              <span class="row-value mono">{{ detail.settlement?.utr }}</span>
            </div>

          </div>

          <a class="section-link"
             *ngIf="detail.settlement?.invoice_url"
             [href]="detail.settlement?.invoice_url"
             target="_blank"
             rel="noopener">
            <i class="bi bi-eye"></i> View Settlement Invoice
          </a>

          <button class="section-link section-link-btn"
                  *ngIf="detail.settlement?.payout_id"
                  (click)="viewRelatedPayout(detail.settlement?.payout_id)">
            <i class="bi bi-eye"></i> View Payout Details
          </button>
        </div>

        <div class="detail-section">
          <div class="section-title">Appointment Timeline</div>

          <div class="timeline" *ngIf="detail.timeline?.length">
            <div class="timeline-item" *ngFor="let event of detail.timeline">
              <i class="bi" [ngClass]="timelineIcon(event.type)"></i>
              <span class="timeline-title">{{ event.title }}</span>
              <span class="timeline-time">{{ formatDateTime(event.timestamp) }}</span>
            </div>
          </div>

          <p class="section-empty" *ngIf="!detail.timeline?.length">
            No timeline events recorded.
          </p>
        </div>

      </div>

      <!-- ── Payout detail ── -->
      <div class="detail-body"
           *ngIf="!detailLoading && detail && detailKind === 'payout'">

        <div class="detail-head-row">
          <span class="detail-id"
                [title]="detail.payout?.razorpay_payout_id || detail.payout?.payout_id">
            {{ detail.payout?.razorpay_payout_id || shortId(detail.payout?.payout_id) }}
          </span>

          <span class="status-badge" [ngClass]="paymentStatusClass(detail.payout?.status)">
            {{ statusLabel(detail.payout?.status) }}
          </span>
        </div>

        <div class="detail-section">
          <div class="section-title">Payout Summary</div>

          <div class="detail-rows">

            <div class="row-item">
              <span class="row-label">Payout ID</span>
              <span class="row-value mono copy-value"
                    [title]="detail.payout?.payout_id">
                {{ detail.payout?.razorpay_payout_id
                   || shortId(detail.payout?.payout_id) }}
                <button class="copy-btn"
                        title="Copy payout id"
                        (click)="copy(detail.payout?.razorpay_payout_id
                                      || detail.payout?.payout_id, 'Payout ID')">
                  <i class="bi bi-clipboard"></i>
                </button>
              </span>
            </div>

            <div class="row-item">
              <span class="row-label">Payout Date</span>
              <span class="row-value">
                {{ formatDateTime(detail.payout?.payout_date) }}
              </span>
            </div>

            <div class="row-item">
              <span class="row-label">Status</span>
              <span class="status-badge"
                    [ngClass]="paymentStatusClass(detail.payout?.status)">
                {{ statusLabel(detail.payout?.status) }}
              </span>
            </div>

            <div class="row-item">
              <span class="row-label">UTR / Reference</span>
              <span class="row-value mono">
                {{ detail.payout?.utr || detail.payout?.reference_id || '-' }}
              </span>
            </div>

            <div class="row-item">
              <span class="row-label">Total Appointments</span>
              <span class="row-value">{{ detail.summary?.appointments || 0 }}</span>
            </div>

            <div class="row-item">
              <span class="row-label">Gross Amount</span>
              <span class="row-value">
                {{ money(detail.summary?.gross_amount, detail.summary?.currency) }}
              </span>
            </div>

            <div class="row-item">
              <span class="row-label">Lawyer Payable (Net)</span>
              <span class="row-value positive">
                {{ money(detail.summary?.net_payable, detail.summary?.currency) }}
              </span>
            </div>

            <div class="row-item">
              <span class="row-label">Platform Fee &amp; Taxes</span>
              <span class="row-value">
                {{ money(detail.summary?.platform_fee_and_taxes,
                         detail.summary?.currency) }}
              </span>
            </div>

            <div class="row-item" *ngIf="detail.payout?.failure_reason">
              <span class="row-label">Failure Reason</span>
              <span class="row-value">{{ detail.payout?.failure_reason }}</span>
            </div>

          </div>
        </div>

        <div class="detail-section" *ngIf="detail.invoices?.length">
          <div class="section-title">
            Included Settlement Invoices ({{ detail.invoices.length }})
          </div>

          <div class="invoice-table">
            <table class="table">
              <thead>
                <tr>
                  <th>Invoice Code</th>
                  <th>Appointment</th>
                  <th>Client</th>
                  <th class="text-end">Net Payable</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let invoice of detail.invoices; trackBy: trackByInvoice">
                  <td>
                    <a *ngIf="invoice.invoice_url"
                       class="link-text"
                       [href]="invoice.invoice_url"
                       target="_blank"
                       rel="noopener">{{ invoice.invoice_code || '-' }}</a>
                    <span *ngIf="!invoice.invoice_url">
                      {{ invoice.invoice_code || '-' }}
                    </span>
                  </td>
                  <td>
                    <span class="mono" [title]="invoice.appointment_id || ''">
                      {{ shortId(invoice.appointment_id) }}
                    </span>
                  </td>
                  <td>{{ invoice.client_name || '-' }}</td>
                  <td class="text-end">
                    {{ money(invoice.net_payable, invoice.currency) }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div class="detail-section">
          <div class="section-title">Payout Timeline</div>

          <div class="timeline" *ngIf="detail.timeline?.length">
            <div class="timeline-item" *ngFor="let event of detail.timeline">
              <i class="bi" [ngClass]="timelineIcon(event.type)"></i>
              <span class="timeline-title">{{ event.title }}</span>
              <span class="timeline-time">{{ formatDateTime(event.timestamp) }}</span>
            </div>
          </div>

          <p class="section-empty" *ngIf="!detail.timeline?.length">
            No timeline events recorded.
          </p>
        </div>

      </div>

      <!-- ── Activity detail ── -->
      <div class="detail-body"
           *ngIf="!detailLoading && detail && detailKind === 'activity'">

        <div class="activity-head">
          <span class="activity-icon activity-icon-lg"
                [ngClass]="activityTone(detail.type)">
            <i class="bi" [ngClass]="activityIcon(detail.type)"></i>
          </span>
          <div>
            <div class="activity-head-title">
              {{ detail.title }}
              <span class="ref-chip" *ngIf="detail.reference" [title]="detail.reference">
                {{ shortId(detail.reference) }}
              </span>
            </div>
            <div class="cell-sub">{{ formatDateTime(detail.timestamp) }}</div>
          </div>
        </div>

        <div class="detail-section">
          <div class="section-title">Overview</div>

          <div class="detail-rows">

            <div class="row-item">
              <span class="row-label">Event Type</span>
              <span class="row-value">{{ detail.title }}</span>
            </div>

            <div class="row-item">
              <span class="row-label">Description</span>
              <span class="row-value">{{ detail.description || '-' }}</span>
            </div>

            <div class="row-item">
              <span class="row-label">Performed By</span>
              <span class="row-value">{{ detail.performed_by || 'System' }}</span>
            </div>

            <div class="row-item">
              <span class="row-label">Occurred At</span>
              <span class="row-value">{{ formatDateTime(detail.timestamp) }}</span>
            </div>

          </div>
        </div>

        <div class="detail-section"
             *ngIf="detail.payout_id || detail.appointment_id || detail.payment_id
                    || detail.refund_id || detail.client?.name || detail.amount">
          <div class="section-title">Related Information</div>

          <div class="detail-rows">

            <div class="row-item" *ngIf="detail.payout_id">
              <span class="row-label">Payout ID</span>
              <span class="row-value mono copy-value" [title]="detail.payout_id">
                {{ shortId(detail.payout_id) }}
                <button class="copy-btn"
                        title="Copy payout id"
                        (click)="copy(detail.payout_id, 'Payout ID')">
                  <i class="bi bi-clipboard"></i>
                </button>
              </span>
            </div>

            <div class="row-item" *ngIf="detail.appointment_id">
              <span class="row-label">Appointment ID</span>
              <span class="row-value mono copy-value" [title]="detail.appointment_id">
                {{ shortId(detail.appointment_id) }}
                <button class="copy-btn"
                        title="Copy appointment id"
                        (click)="copy(detail.appointment_id, 'Appointment ID')">
                  <i class="bi bi-clipboard"></i>
                </button>
              </span>
            </div>

            <div class="row-item" *ngIf="detail.payment_id">
              <span class="row-label">Payment ID</span>
              <span class="row-value mono">{{ detail.payment_id }}</span>
            </div>

            <div class="row-item" *ngIf="detail.refund_id">
              <span class="row-label">Refund ID</span>
              <span class="row-value mono" [title]="detail.refund_id">
                {{ shortId(detail.refund_id) }}
              </span>
            </div>

            <div class="row-item" *ngIf="detail.client?.name">
              <span class="row-label">Client</span>
              <span class="row-value">{{ detail.client?.name }}</span>
            </div>

            <div class="row-item" *ngIf="detail.amount">
              <span class="row-label">Amount</span>
              <span class="row-value">{{ money(detail.amount) }}</span>
            </div>

          </div>
        </div>

        <button class="section-link section-link-btn"
                *ngIf="detail.payout_id"
                (click)="viewRelatedPayout(detail.payout_id)">
          <i class="bi bi-eye"></i> View Payout Details
        </button>

        <button class="section-link section-link-btn"
                *ngIf="detail.appointment_id"
                (click)="viewRelatedAppointment(detail.appointment_id)">
          <i class="bi bi-eye"></i> View Related Appointment
        </button>

      </div>

      <!-- Detail loading -->
      <div class="detail-body" *ngIf="detailLoading">
        <div class="skeleton-wrapper">
          <div class="skeleton-block" *ngFor="let block of [1,2,3,4]"></div>
        </div>
      </div>

      <!-- Detail unavailable -->
      <div class="detail-body" *ngIf="!detailLoading && !detail">
        <div class="empty-state">
          <i class="bi bi-exclamation-circle empty-icon"></i>
          <p class="empty-title">Details unavailable</p>
          <p class="empty-sub">This record could not be loaded.</p>
        </div>
      </div>

    </aside>

  </div>

</div>
